import { render, staticRenderFns } from "./KnAlert.vue?vue&type=template&id=6562ca05"
import script from "./KnAlert.vue?vue&type=script&lang=js"
export * from "./KnAlert.vue?vue&type=script&lang=js"
import style0 from "./KnAlert.vue?vue&type=style&index=0&id=6562ca05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports